export default "__VITE_ASSET__BtTYqH7A__"